import React from "react";
import { t } from "../../helpers/translate";
import Icon from "react-fa";

class CategoryProducts extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  productComparisonTable = () => {
    const { products } = this.props;
    const allFeatureKeys = [];
    const popularProducts = [
      "Discover Canada",
      "Canuck Voyage",
      "Gold International Student Plan",
      "Silver International Student Plan"
    ];

    products.forEach(product => {
      Object.keys(product.feature_details).forEach(key => {
        if (allFeatureKeys.indexOf(key) === -1) {
          allFeatureKeys.push(key);
        }
      });
    });

    return (
      <div className="comparison-container">
        <h2 className="text-center category-title">{products[0].category_name}</h2>
        
        <div className="table-responsive">
          <table className="table table-bordered comparison-table">
            <thead>
              <tr>
                <th className="empty-corner"></th>
                {products.map((product, index) => {
                  const isPopular = popularProducts.indexOf(product.product_name) !== -1;

                  return (
                    <th key={index} className={isPopular ? "popular-column" : ""}>
                      {isPopular && (
                        <div className="popular-header-banner">
                          {t("Most Popular")}
                        </div>
                      )}
                      <div className="product-info">
                        <h4 className="product-name">{product.product_name}</h4>
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {allFeatureKeys.map((featureKey, rowIndex) => (
                <tr key={rowIndex}>
                  <td className="feature-label">
                    <strong>{featureKey}</strong>
                  </td>
                  {products.map((product, colIndex) => {
                    const value = (product.category_name === 'International Students' && featureKey === 'Quebec Residents') ? this.quebecResidentsInfoLink() : product.feature_details[featureKey];
                    return (
                      <td key={colIndex} className="feature-value">
                        {value ? value : <span className="text-muted">—</span>}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  contactInfo() {
    return (
      <div className="contact-info">
        <p>{t("Please contact us if you have any questions or concerns:")}</p>
        <p><strong>{t("Email")}:</strong> Agent@americas.msh-intl.com</p>
        <p><strong>{t("Fax")}:</strong> 416-730-1878 (or toll-free at 1-800-292-9460)</p>
        <p><strong>{t("By mail")}:</strong> 150 King St West, Suite 602, P.O. Box 75, Toronto, ON, M5H 1J9, Canada</p>
        <p><strong>{t("Hours of operation")}:</strong><br/>{t("Monday to Friday – 9 AM to 5 PM EST")}<br/>({t("We are open most holidays, 9 AM to 5 PM")})</p>
      </div>
    );
  }

  quebecResidentsInfoLink() {
    return <p>For more information with regards to the name and contact information of the insurer, together with the warnings about the consequences of misrepresentation or concealment, please <a href='https://www.mshtravel.com/res/pdfs/general/QUEBEC_RESIDENTS_INFORMATION_ENG.pdf' target='_blank'>click here.</a></p>
  }

  handleComparisonModal(category) {
    this.props.showProductModal(t(category), 'lg', this.productComparisonTable());
  }

  handleContactModal() {
    this.props.showContactModal(t("Contact Us"), this.contactInfo());
  }

  render() {
    const { products, selectedCategory, handleReturnButton } = this.props;

    return (
      <div className="container category-products-page">
        <div className="row">
          <div className="col-xs-12 text-center">
            <h3 className="category-title">{selectedCategory}</h3>
          </div>
        </div>
        <div className="col-md-offset-1 margin-bottom" >
          <button
            className="btn button-secondary"
            onClick={() => { handleReturnButton() }}
          >
            <Icon name="chevron-left" /> {t("Return to Previous Page")}
          </button>
        </div>
        <div className="row product-list-wrapper">
          <div className="col-md-10 col-md-offset-1 col-xs-12">
            {products.map((product, i) => (
              <div key={i} className="product-card">
                <div className="row">
                  <div className="col-sm-2 col-xs-12 text-center product-icon-wrapper">
                    <div className="product-icon-circle">
                      <img
                        src={this.props.categoryIcon}
                        alt="icon"
                        className="img-responsive"
                      />
                    </div>
                  </div>
                  <div className="col-sm-7 col-xs-12 product-content">
                    <h4
                      className="product-name"
                      onClick={() => this.props.handlePolicyData(product)}
                    >
                      {product.product_name}
                    </h4>
                  </div>

                  <div className="col-sm-3 col-xs-12 text-right product-action product-content btn-group">
                    {product.product_link ?
                      this.props.renderProductLinkButton(product.product_link, 'Buy Now') :
                      <span className="margin-search-policies">
                        <div
                          className="btn button-secondary button-minor mobile-top-padding call-us"
                          onClick={() => this.handleContactModal()}><span className="fa fa-phone fa-lg btn-app"></span>
                          {t('Call Us')}
                        </div>
                      </span>
                    }
                  </div>
                </div>
              </div>
            ))}

            <div className="text-center compare-wrapper">
              <button className="btn button-secondary compare-btn" onClick={() => this.handleComparisonModal()}>
                Compare Plans
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CategoryProducts;



// WEBPACK FOOTER //
// ./src/components/common/CategoryProducts.js